import { state } from './state';

const mutations = {
  setVideoStage(stage) {
    state.video.videoStage.value = stage;
  },
  setSelectedVid(vid) {
    state.video.selectedVid.value = vid;
  },
  setCampaignDataList(campaignList) {
    state.campaignList.campaignListData.value = campaignList;
  },
  setObjectiveFilter(objectiveFilter) {
    state.campaignList.objectiveFilter.value = objectiveFilter;
  },
  setStatusFilter(statusFilter) {
    state.campaignList.statusFilter.value = statusFilter;
  },
  setSourceFilter(sourceFilter) {
    state.campaignList.sourceFilter.value = sourceFilter;
  },
};

export default mutations;
